"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* Opening the send sheet from outside the composer: a chat card's Send again
 * (same chat), or the Sent tab's Send again (opens the chat, then the sheet).
 * The open chat's composer registers itself; a request for a chat that isn't
 * open waits until that chat's composer registers. */


let open = null
let pending = null

 const registerSendFormOpener = (conversationKey, opener) => {
  const mine = { conversationKey, opener }
  open = mine
  if (_optionalChain([pending, 'optionalAccess', _ => _.conversationKey]) === conversationKey) {
    const { formKey } = pending
    pending = null
    opener(formKey)
  }
  return () => { if (open === mine) open = null }
}; exports.registerSendFormOpener = registerSendFormOpener

 const requestSendForm = (conversationKey, formKey) => {
  if (_optionalChain([open, 'optionalAccess', _2 => _2.conversationKey]) === conversationKey) {
    open.opener(formKey)
    return
  }
  pending = { conversationKey, formKey }
}; exports.requestSendForm = requestSendForm
